import React from 'react';
import '../less';
import { Link } from "MWComponents";
import title_img from "../img/title_img.png";
import CustomDropdown from "../../../auxiliary-components/shared/CustomDropdown";

export default function template() {
  const isMobile = this.isViewportMobile(),
    widgetData = this.state.widgets.find(widget => widget.code === 'archives') ? this.state.widgets.find(widget => widget.code === 'archives').data : [],
    sortedWidget = this.filterSlidesByEnvironment(widgetData),
    offers = sortedWidget.sort((a, b) => b.order - a.order).map((item, index) => {
      const files = item.files && item.files.length ?
        item.files.sort((a, b) => a.order - b.order).map( (file, index) => {
          const filePath = this.changeFilesUrl(file.path);
          const fileLink = file.link;
          const text = file.title;
          return (<div key={index} className="documents-component-item">
            <Link href={fileLink ? fileLink : filePath} target="_blank">
              <img src={this.changeFilesUrl(file.image)} alt='doc-img'></img>
              <div dangerouslySetInnerHTML={{__html: text}}></div>
            </Link>
          </div>)
          })
        :
        "";
      return (
        files ?
        <div className='archive-item' key={index}>
          <CustomDropdown classNameItems='archive' classNameDropDown='archive'  title={item.title} subtitle={isMobile ? item.desc_mobile : item.desc_desktop} titleTag={"h2"}>
            <h3 className="documents-component-title" dangerouslySetInnerHTML={{__html: this.l10n('ARCHIVE_WINNERS')}}></h3>
            {files}
          </CustomDropdown>
          {item.link || item.path ?
            <a href={item.link ? item.link : item.path ? this.changeFilesUrl(item.path) : ''} className='archive-item-link' target='_blank'>{this.l10n('ARCHIVE_LINK_TEXT')}</a>
            :
            ''
          }
        </div>
          :
          <div className='archive-item' key={index}>
            <h2 className='archive-item-title' dangerouslySetInnerHTML={{__html: item.title}}></h2>
            <div className='archive-item-subtitle' dangerouslySetInnerHTML={{__html: isMobile ? item.desc_mobile : item.desc_desktop}}></div>
            {item.link || item.path ?
              <a href={item.link ? item.link : item.path ? this.changeFilesUrl(item.path) : ''} className='archive-item-link' target='_blank'>{this.l10n('ARCHIVE_LINK_TEXT')}</a>
              :
              ''
            }
          </div>
      )
    });

  return (
    <div className='module-archive'>
      <div className='content'>
        <div className='title-block'>
          <div className='title-block-left'>
            <h1 className='title-block-title'>{this.l10n('ARCHIVE_HEADING')}</h1>
            <div className='title-block-text' dangerouslySetInnerHTML={{__html: this.l10n('ARCHIVE_HEADING_DESC')}}></div>
          </div>
          <img className='title-block-img' src={title_img} alt="title_img" />
        </div>
        <div className='archive-wrapper'>
          {offers}
        </div>
      </div>
    </div>
  );
}
